import * as React from 'react';

import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';

import { NotificationsOutlined, } from '@mui/icons-material';
import { Avatar, ListItem, ListItemAvatar, ListItemButton, ListItemText, Menu } from '@mui/material';
import { useState } from 'react';



const Notification = () => {

    const [anchorEl, setAnchorEl] = useState(null);

    const notMenu = Boolean(anchorEl);

    const handleNot = (e) => {
        // setAnchorEl(e.currentTarget);
    };

    const handleNotClose = () => {
        setAnchorEl(null);
    }

    return (
        <>
            <IconButton color="inherit" onClick={handleNot} >
                {/* <Badge badgeContent={4} color="error"> */}
                    <NotificationsOutlined />
                {/* </Badge> */}
            </IconButton>

            <Menu anchorEl={anchorEl}
                open={notMenu}
                onClose={handleNotClose}>


                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                    <ListItem alignItems="flex-start">
                        <ListItemButton onClick={handleNotClose}>

                            <ListItemAvatar>
                                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                            </ListItemAvatar>
                            <ListItemText
                                primary="Brunch this weekend?"
                                secondary={
                                    <React.Fragment>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                        >
                                            Ali Connors
                                        </Typography>
                                        {" — I'll be in your neighborhood doing errands this…"}
                                    </React.Fragment>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start">
                        <ListItemButton onClick={handleNotClose}>
                            <ListItemAvatar>
                                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
                            </ListItemAvatar>

                            <ListItemText
                                primary="Summer BBQ"
                                secondary={
                                    <React.Fragment>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                        >
                                            to Scott, Alex, Jennifer
                                        </Typography>
                                        {" — Wish I could come, but I'm out of town this…"}
                                    </React.Fragment>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start">
                        <ListItemButton onClick={handleNotClose}>

                            <ListItemAvatar>
                                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
                            </ListItemAvatar>
                            <ListItemText
                                primary="Oui Oui"
                                secondary={
                                    <React.Fragment>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                        >
                                            Sandra Adams
                                        </Typography>
                                        {' — Do you have Paris recommendations? Have you ever…'}
                                    </React.Fragment>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                </List>

            </Menu>
        </>
    )
}

export default Notification